export enum DialogSize {
  SM = 'modal-sm',
  LG = 'modal-lg',
  XL = 'modal-xl',
  LGScroll = 'modal-lg modal-dialog-scrollable'
}

export enum DialogFlag {
  ReloadRequired = 'ReloadRequired'
}
